import { NO_PATH } from "../constants";

export const utf8ToBase64 = (str) => {
  if (typeof str !== 'string' || str === '' || str === '/') {
    return "";
  }

  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(`0x${p1}`)));
}

export const base64ToUtf8 = (str) => {
  if (typeof str !== 'string' || str === '' || str === '/') {
    return "";
  }
  
  return decodeURIComponent(Array.prototype.map.call(atob(str), (c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
}

export const getDecodedRedirectPath = (encodedRedirecPath) => {
  const redirectPath = base64ToUtf8(encodedRedirecPath);
  return redirectPath === NO_PATH ? "" : redirectPath || "";
}